import React from 'react';

function WelcomeModal({ isOpen, isSaving, roleLabel, onStart, onLater, onSkip }) {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay" role="presentation">
      <div className="modal" role="dialog" aria-modal="true" aria-label="Welcome tour">
        <h3>Welcome to your workspace</h3>
        <p className="helper-text">
          This quick walkthrough follows the core setup path for this workspace and only shows the tabs available to your {roleLabel} access.
        </p>
        <div className="onboarding-list" style={{ marginTop: 16 }}>
          <div className="onboarding-item">
            <div className="onboarding-item-copy">
              <strong>Start guided tour</strong>
              <p>Walk through the setup flow in the order most teams should use it.</p>
            </div>
          </div>
          <div className="onboarding-item">
            <div className="onboarding-item-copy">
              <strong>Follow launch checklist</strong>
              <p>Track the highest-priority setup steps without leaving the dashboard.</p>
            </div>
          </div>
        </div>
        <div className="modal-actions">
          <button type="button" onClick={onSkip} disabled={isSaving}>
            Don't Show Again
          </button>
          <button type="button" className="btn-edit" onClick={onLater} disabled={isSaving}>
            Remind Me Tomorrow
          </button>
          <button type="button" className="btn-primary" onClick={onStart} disabled={isSaving}>
            {isSaving ? 'Saving...' : 'Start Tour'}
          </button>
        </div>
      </div>
    </div>
  );
}

export default WelcomeModal;
